/*
 * @Author: Fangxh 1745955087@qq.com
 * @Date: 2022-11-18 14:22:21
 * @LastEditors: Fangxh 1745955087@qq.com
 * @LastEditTime: 2022-11-24 17:24:21
 * @FilePath: \eampro-front\src\api\organizationalStructure.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

// 获取分组织架构树
export function getCompanyTree (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/company/tree',
    method: 'GET',
    params: parameter
  })
}
// 获取组织架构列表
export function getUserList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/user/info',
    method: 'GET',
    params: parameter
  })
}
// 同步全部信息
export function setSync (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/sync/all',
    method: 'post',
    data: parameter
  })
}

// 配置角色
export function saveUserRole (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/user/saveUserRole',
    method: 'PUT',
    data: parameter
  })
}
